import { loadStudentActivationFunctionality } from "../../Administration/StudentActivation/ActivateFunctionality";
import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { loadTooltips } from "../../Utils/Ajax/loadTooltips";
import { UserManagement } from "../../Utils/UserManagement/UserManagement";
import { getCourseId, makeModal, showSpinner, successToast } from "../../Utils/utils";
import { changeCourseListItem } from "../AdminCourseManagement/Fills";
import { loadDt } from "../AdminCourseManagement/loadDt";

function loadTable(type = 'normal'){
    const table = $("#tutor-users-table").find("table")
    const config = loadDt(table)
    config.columnDefs = [
        {"orderable": false, "targets": [3, 5]}
    ]

    if (type == 'invited'){
        config.columnDefs = [
            {"orderable": false, "targets": [2, 3]}
        ]
    }

    table.DataTable(config);
}

export function loadUserManagement(){

    const courseId = Number($("#course-id").val())

    loadTable();

    $(".load-users").on("click", function(){
        const type = $(this).attr('data-type');
        changeCourseListItem($(this));

        const url = '/course/' + courseId.toString() + '/tutor/students/' + type

        const success = function (data){
            $("#tutor-users-table").html(data.html);
        }

        ajaxRequest(url, success, {}, $(this)).then((response) => {
            loadTable(type);
            loadTooltips()
        })

    });

    $("#tutor-users-table").on("click", ".remove-user-invitation", function(){

        const btn = $(this)
        const mail = btn.attr('data-email')

        const confirmed = confirm("Sicher, dass du die Einaldung für die E-Mail: " + mail.toString() + " zurückziehen möchtest?")

        if (confirmed){

        const url = '/course/' + courseId.toString() + '/user/uninvite'

        const data = {
            mail: mail
        }

        const success = function (data){
            successToast("Einladung wurde gelöscht", "Erfolg")
            btn.parents('tr').remove();
        }

        ajaxRequest(url, success, data, btn)

        }
    });

    $("#tutor-users-table").on("click", ".load-user-reset", function(){

        const content = '<div id="user-reset-wrapper">'+
        '<p>Ein/-e Schüler/-in ist anonym angemeldet (ohne E-Mail) und hat sein/ihr Passwort oder Benutzernamen vergessen?</h4>' + 
        '<p class="mt-2 text-muted">Hier können Sie einen Link erstellen, über den ihr/-e Schüler/-in den Account mit einer Sicherheitsfrage wieder freischalten kann.' + 
        '<div class="text-center mt-2">' + 
            '<button id="create-reset-code" class="btn btn-lg btn-light-success text-success">Wiederherstellungslink generieren</button>'+
        '</div>' + 
        '<input id="reset-user-id" type="hidden" value="">' + 
        '<div class="mt-4 user-select-all text-center" style="max-width: 100%;" id="reset-code"></div>'+
        '</div>'

        const modal = makeModal('user-reset-code', 'Zugangsdaten wiederbekommen', content, {}, false, 'md');
        modal.show();

        $("#reset-user-id").val($(this).attr('data-user'))

    })

    $(document).on("click", "#create-reset-code", function(){

        const url = "/reset-user/" + getCourseId().toString() + '/' + $("#reset-user-id").val().toString() + '/create'

        const success = function(data){
            successToast("Wiederherstellungslink erfolgreich erstellt")
            $("#reset-code").html(data.link)
        }

        ajaxRequest(url, success, {}, $(this))

    })



    new UserManagement(courseId);

    loadStudentActivationFunctionality(courseId, 'tutor');

}